import { GTMAccommodationItem } from "@/helpers/gtm/GTMAccommodationItem.ts";
import { GTMEvent } from "@/helpers/gtm/GTMEvent.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import TagManager from "react-gtm-module";

// Tracks whenever user clicks anywhere in the single accommodation card
export const handleGTMRemoveAccommodationFromCart = (cartItem: CartAccommodationItem) => {
  const RP = cartItem.ratePlan;
  const RG = cartItem.ratePlan.rateGroup;

  const selecteditem: GTMAccommodationItem = {
    item_id: RP.id,
    item_name: RP.name,
    currency: "EUR",
    // price is innacurate, because if perOccupancy, price is different per number of guests
    price: RP.lowestPrice,
    item_category: RG.name,
    index: 0,
    quantity: 1,
  };

  TagManager.dataLayer({
    dataLayer: {
      event: GTMEvent.RemoveFromCart,
      ecommerce: {
        currency: "EUR",
        value: RP.lowestPrice,
        items: [selecteditem],
      },
    },
  });
};
